import { createAction, props } from "@ngrx/store";
import { SiteModel, AssetModel } from "../models/asset.model";

export const ADD_SITES = createAction(
  "ADD_SITES",
  props<{ sites: SiteModel[] }>(),
);
export const ADD_ASSETS = createAction(
  "ADD_ASSETS",
  props<{ assets: AssetModel[] }>(),
);

export const REMOVE_DROPPED_ASSET = createAction(
  "REMOVE_DROPPED_ASSET",
  props<AssetModel>(),
);

export const REMOVE_SITES = createAction("REMOVE_SITES");
export const REMOVE_ASSETS = createAction("REMOVE_ASSETS");
export const ADD_SITE = createAction("ADD_SITE", props<SiteModel>());
export const ADD_ASSET = createAction("ADD_ASSET", props<AssetModel>());
export const UPDATE_SITE = createAction("UPDATE_SITE", props<SiteModel>());
export const REMOVE_SITE = createAction("REMOVE_SITE", props<SiteModel>());
export const UPDATE_ASSET = createAction("UPDATE_ASSET", props<AssetModel>());
export const REMOVE_ASSET = createAction("REMOVE_ASSET", props<AssetModel>());
export const UPDATE_ASSETS = createAction("UPDATE_ASSETS",props<{ assets: AssetModel[] }>());
